import { PLAYER, MISSIONS } from '../data';
import { ASSETS } from '../assetManifest';

export const getMissionData = () => {
  return {
    playerEnergy: PLAYER.resources.energy,
    missions: MISSIONS
  };
};
